import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { to: '/', labelKey: 'nav_home' },
    { to: '/turkiye-hakkinda', labelKey: 'nav_about_turkey' },
    { to: '/turkiye-kulturu', labelKey: 'nav_turkey_culture' },
    { to: '/saglik-kurumlari', labelKey: 'nav_health_institutions' },
    { to: '/araci-kurumlar', labelKey: 'nav_agencies' },
    { to: '/iletisim', labelKey: 'nav_contact' },
  ];

  const institutionLinks = [
    { to: '/kurum-paneli', labelKey: 'footer_institution_login' },
    { to: '/uye-ol', labelKey: 'footer_register' },
  ];

  const legalLinks = [
    { to: '/gizlilik-politikasi', labelKey: 'footer_privacy' },
    { to: '/kvkk-aydinlatma-metni', labelKey: 'footer_kvkk' },
    { to: '/kullanim-kosullari', labelKey: 'footer_terms' },
  ];

  return (
    <footer style={{ background: '#ffffff', color: '#1f2937', fontFamily: '\'Segoe UI\', sans-serif', borderTop: '1px solid #e5e7eb' }}>
      <div style={{ width: '100%', padding: '48px 32px' }}>
        <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 1.5fr', gap: '40px', alignItems: 'start' }}>

          {/* Logo & Description */}
          <div>
            <a href="/" style={{ display: 'flex', alignItems: 'center', gap: '12px', textDecoration: 'none', marginBottom: '16px' }}>
              <img
                src="https://static.readdy.ai/image/bfc79f7fd8a7c30d01849985af6cf205/f8d8b7469b2153fc0f5999277b98f4f1.png"
                alt="Health Travel Türkiye Logo"
                style={{ width: '240px', height: '94px', objectFit: 'contain', flexShrink: 0, borderRadius: '8px' }}
              />
            </a>
            <p style={{ color: '#6b7280', fontSize: '0.875rem', lineHeight: 1.6 }}>
              {t('footer_description')}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 style={{ fontSize: '1rem', fontWeight: 600, color: '#111827', marginBottom: '16px' }}>
              {t('footer_quick_links')}
            </h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '10px' }}>
              {quickLinks.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    style={{ color: '#6b7280', fontSize: '0.875rem', textDecoration: 'none' }}
                    onMouseEnter={e => (e.currentTarget.style.color = '#111827')}
                    onMouseLeave={e => (e.currentTarget.style.color = '#6b7280')}
                  >
                    {t(item.labelKey)}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* For Institutions */}
          <div>
            <h4 style={{ fontSize: '1rem', fontWeight: 600, color: '#111827', marginBottom: '16px' }}>
              {t('footer_for_institutions')}
            </h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '10px' }}>
              {institutionLinks.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    style={{ color: '#6b7280', fontSize: '0.875rem', textDecoration: 'none' }}
                    onMouseEnter={e => (e.currentTarget.style.color = '#111827')}
                    onMouseLeave={e => (e.currentTarget.style.color = '#6b7280')}
                  >
                    {t(item.labelKey)}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 style={{ fontSize: '1rem', fontWeight: 600, color: '#111827', marginBottom: '16px' }}>
              {t('footer_contact')}
            </h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                <i className="ri-mail-line" style={{ color: '#6b7280', fontSize: '1rem', marginTop: '2px' }}></i>
                <a href="mailto:healthtravelturkiye@gmail.com" style={{ color: '#6b7280', fontSize: '0.875rem', textDecoration: 'none' }}
                  onMouseEnter={e => (e.currentTarget.style.color = '#111827')}
                  onMouseLeave={e => (e.currentTarget.style.color = '#6b7280')}
                >
                  healthtravelturkiye@gmail.com
                </a>
              </div>
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                <i className="ri-map-pin-line" style={{ color: '#6b7280', fontSize: '1rem', marginTop: '2px' }}></i>
                <span style={{ color: '#6b7280', fontSize: '0.875rem', lineHeight: 1.5 }}>
                  {t('footer_address_value')}
                </span>
              </div>
            </div>
          </div>

        </div>

        {/* Bottom Bar */}
        <div style={{ borderTop: '1px solid #e5e7eb', marginTop: '40px', paddingTop: '24px', display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', alignItems: 'center', gap: '12px' }}>
          <p style={{ color: '#9ca3af', fontSize: '0.8rem' }}>
            &copy; {currentYear} Health Travel Türkiye. {t('footer_rights')}
          </p>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px' }}>
            {legalLinks.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                style={{ color: '#9ca3af', fontSize: '0.8rem', textDecoration: 'none' }}
                onMouseEnter={e => (e.currentTarget.style.color = '#111827')}
                onMouseLeave={e => (e.currentTarget.style.color = '#9ca3af')}
              >
                {t(item.labelKey)}
              </Link>
            ))}
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="nofollow noopener noreferrer"
              style={{ color: '#9ca3af', fontSize: '0.8rem', textDecoration: 'none' }}
              onMouseEnter={e => (e.currentTarget.style.color = '#111827')}
              onMouseLeave={e => (e.currentTarget.style.color = '#9ca3af')}
            >
              {t('footer_powered')}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
